import Axios from "axios";
import {
  getAllSupplierNoticesRequest,
  getNoticesResponse,
  getSelectResponse,
  noticeDetailRequest,
  noticeSummaryResponse,
  updateSupplierNoticePinRequest,
} from "../models/SupplierNotice.model";
import { ApiResultModel } from "../models/common.model";
import { ApiBaseUrl, SupplierNoticeBaseUrl } from "../config/config";

export const GetAllLoginNotices = (): Promise<getNoticesResponse[]> => {
  return Axios.post<ApiResultModel<getNoticesResponse[]>>(
    ApiBaseUrl + SupplierNoticeBaseUrl + "/GetAllLoginNotices"
  ).then((result) => {
    return result.data.data;
  });
};

export const GetCurrentNotices = (): Promise<getNoticesResponse[]> => {
  return Axios.post<ApiResultModel<getNoticesResponse[]>>(
    ApiBaseUrl + SupplierNoticeBaseUrl + "/GetCurrentNotices"
  ).then((result) => {
    return result.data.data;
  });
};

export const GetNoticeDetail = (
  data: noticeDetailRequest
): Promise<getNoticesResponse[]> => {
  return Axios.post<ApiResultModel<getNoticesResponse[]>>(
    ApiBaseUrl + SupplierNoticeBaseUrl + "/GetSupplierNoticeDetail",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetAllSupplierNotices = (
  data: getAllSupplierNoticesRequest
): Promise<ApiResultModel<getNoticesResponse[]>> => {
  return Axios.post<ApiResultModel<getNoticesResponse[]>>(
    ApiBaseUrl + SupplierNoticeBaseUrl + "/GetAllSupplierNotices",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetSupplierNoticeSummary = (): Promise<noticeSummaryResponse> => {
  return Axios.post<ApiResultModel<noticeSummaryResponse>>(
    ApiBaseUrl + SupplierNoticeBaseUrl + "/GetSupplierNoticeSummary"
  ).then((result) => {
    return result.data.data;
  });
};

export const UpdateSupplierNoticePin = (
  data: updateSupplierNoticePinRequest
): Promise<boolean> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + SupplierNoticeBaseUrl + "/UpdateSupplierNoticePin",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const UpdateSupplierNoticeViewDate = (
  data: noticeDetailRequest
): Promise<boolean> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + SupplierNoticeBaseUrl + "/UpdateSupplierNoticeViewDate",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetNoticeTypes = (): Promise<getSelectResponse[]> => {
  return Axios.post<ApiResultModel<getSelectResponse[]>>(
    ApiBaseUrl + SupplierNoticeBaseUrl + "/GetNoticeTypes"
  ).then((result) => {
    return result.data.data;
  });
};
